import { Box, Typography, useTheme } from "@mui/material";
import { InfoOutlined, Sync } from "@mui/icons-material";
import { tokens } from "../../theme";
import DataGridButton from "../../components/DataGridButton";
import {
  dataGridButtonStyles,
  envListButtonStyles,
} from "../../styles/buttonStyles";
import { styles } from "./styles";

// const primaryButton = (colors) => ({
//   ...dataGridButtonStyles.pageTopButtons,
//   ...envListButtonStyles(colors).toolbarPrimary,
// });

const outlinedButton = (colors) => ({
  ...dataGridButtonStyles.pageTopButtons,
  ...envListButtonStyles(colors).toolbarOutlined,
});

// Shown over the frame when it has not fired onLoad within the timeout.
const FrameFallback = ({ appName, openUrl, openLabel, onRetry }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);

  return (
    <Box sx={styles.fallback}>
      <InfoOutlined sx={styles.fallbackIcon(colors)} />
      <Typography sx={styles.fallbackTitle(colors)}>
        {appName} hasn't loaded yet
      </Typography>
      <Typography sx={styles.fallbackBody(colors)}>
        The embedded frame is still waiting on {appName}, or your browser
        blocked its login cookie. Open {appName} in a new tab, sign in there,
        then come back and reload.
      </Typography>
      <Box sx={styles.fallbackActions}>
        {/* TODO: Add this back when we have a url to redirect available */}
        {/* <DataGridButton
          sx={primaryButton(colors)}
          onClick={() => window.open(openUrl, "_blank", "noopener,noreferrer")}
          toolTipProps={{ title: `Open ${appName} in a new browser tab` }}
        >
          <OpenInNew sx={{ fontSize: 16, color: "#fff" }} />
          <Typography>{openLabel}</Typography>
        </DataGridButton> */}
        <DataGridButton
          sx={outlinedButton(colors)}
          onClick={onRetry}
          toolTipProps={{ title: "Reload the embedded frame" }}
        >
          <Sync sx={{ fontSize: 16 }} />
          <Typography>RELOAD</Typography>
        </DataGridButton>
      </Box>
    </Box>
  );
};

export default FrameFallback;
